import { useNuxtApp } from "#app";

interface ApiNewsItem {
  id: number;
  heading: string;
  meta: string;
  slug: string;
  formattedCreated: string;
}

export interface NewsItem {
  id: number;
  heading: string;
  meta: string;
  slug: string;
  created: string;
}

export async function useNewsFetcher(limit: number): Promise<NewsItem[]> {
  const response = await $fetch<{ data: ApiNewsItem[] }>("/api/news", {
    query: { limit },
  });

  if (!response?.data) return [];

  return response.data.map(
    (item): NewsItem => ({
      id: item.id,
      heading: item.heading,
      meta: item.meta,
      slug: item.slug,
      created: item.formattedCreated,
    }),
  );
}
